<template>
  <div class="emprendimiento">
    <!-- <VueSlickCarousel
      :dots="true"
      class="emprendimiento__carousel"
      :autoplay="true"
      :autoplaySpeed="5000"
      :arrows="false"
    >
      <div class="emprendimiento__hero emprendimiento__hero--1">
        <div class="left">
          <h1>
            Shark Tank Colombia <br /> presenta DiDi Lab. <br />
            <span> Laboratorio de ideas para la reactivación del país.</span>
          </h1>
        </div>
        <div></div>
      </div>
      <div class="emprendimiento__hero emprendimiento__hero--2">
        <div class="left">
          <h1>
            ¿Tienes un emprendimiento que <br /> quieres llevar al siguiente nivel?
            <br />
            <span>
              regístrate ya en DiDi Lab y seamos parte de la
              reactivación de la economía.</span
            >
          </h1>
        </div>
        <div></div>
      </div>
      <div class="emprendimiento__hero emprendimiento__hero--3">
        <div class="left">
          <h1>
            El emprendimiento ganador se llevará <br /> 50 millones de pesos para
            invertir en su negocio y una consultoría exclusiva <br />
            <span
              >por parte del Centro de Emprendimiento de la Universidad de los
              Andes.</span
            >
          </h1>
        </div>
        <div></div>
      </div>
    </VueSlickCarousel> -->

    <h2 class="emprendimiento__titulo">EMPRENDIMIENTOS</h2>

    <div class="emprendimiento__empr" v-if="postulacion">
      <div class="left">
        <iframe width="560" height="315" :src="'https://www.youtube.com/embed/'+postulacion.videoId" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <div class="left__datos">
          <p>{{postulacion.nombreEmprendedor}}</p>
          <p>{{postulacion.documento}}</p>
          <p>{{postulacion.celular}}</p>
          <p>{{postulacion.email}}</p>
          <p>{{postulacion.ciudad}}</p>
          <p>{{postulacion.direccion}}</p>
          <p>{{postulacion.nombreRepresentante}}</p>
          <p>{{postulacion.documentoRepresentante}}</p>
        </div>
        <a class="left__link" v-for="link in postulacion.nombresArchivos" :key="link.nombre" :href="link.link" target="_blank">{{link.nombre}}</a>
      </div>
      <div class="right">
        <h3>{{postulacion.nombreEmprendimiento}}</h3>
        <p class="right__direccion">{{postulacion.direccion}}</p>
        <p class="right__descripcion">{{postulacion.descripcion}}</p>

        <div class="right__botones">
          <button type="button" @click="aceptar(postulacion.id)">ACEPTAR</button>
          <button type="button" @click="cancelar(postulacion.id)">Rechazar</button>
        </div>
      </div>
    </div>

    <Allies />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Allies from '@/components/Allies.vue';

import { db } from "../firebase";
import firebase from "firebase/app";

export default {
  components: {
    VueSlickCarousel,
    Allies
  },

  data(){
    return {
      postulacion: null
    }
  },

  async mounted(){
    const uid = this.$route.params.uid;
    const pos = await db.collection("postulaciones").doc(uid).get();

    let nombresArchivos = []
    pos.data().filesUrl.map(link => {
      const str = link.split("/")[7];
      const nombre = str.split("?")[0];
      
      const objNombre = {
        nombre,
        link
      }

      nombresArchivos.push(objNombre);
    })
    this.postulacion = {
      id: pos.id,
      nombresArchivos,
      ...pos.data()
    }
  },

  methods: {
    async aceptar(id) {
      var batch = db.batch();
      batch.update(db.collection("postulaciones").doc(id), {
        aprobado: true
      });
      batch.update(db.collection("stats").doc("stats"), {
        aprobados: firebase.firestore.FieldValue.increment(1)
      })

      try {
        await batch.commit();
        this.$router.push('/dashboard');
      } catch (error) {
        console.log(error);
      }
      /* const ref = db.collection("postulaciones").doc(id);
      await ref.update({
        aprobado: true
      }); */
    },
  
    async cancelar(id) {
      var batch = db.batch();
      batch.update(db.collection("postulaciones").doc(id), {
        rechazado: true
      });
      batch.update(db.collection("stats").doc("stats"), {
        rechazados: firebase.firestore.FieldValue.increment(1)
      })

      try {
        await batch.commit();
        this.$router.push('/dashboard');
      } catch (error) {
        console.log(error);
      }
      /* const ref = db.collection("postulaciones").doc(id);
      await ref.update({
        rechazado: true
      }) */
    },
  }
}
</script>

<style lang="scss" scoped>
  .emprendimiento {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../assets/images/bg.jpg") no-repeat;
    background-size: cover;
    background-position-y: 45%;

    &__carousel {
      width: 100%;
    }

    &__hero {
      height: 70vh;
      width: 100%;
      padding: 2rem 4rem;
      display: grid !important;

      @include phone {
        padding: 1rem 2rem;
        height: 30vh;
      }

      &--1 {
        background: url("../assets/images/home/hero_1.jpg") no-repeat;
        background-size: cover;
        grid-template-columns: 40% 60%;

        @include phone {
          grid-template-columns: 60% 40%;
        }
      }
      &--2 {
        background: url("../assets/images/home/hero_2.jpg") no-repeat;
        background-size: cover;
        grid-template-columns: 50% 50%;

        @include phone {
          grid-template-columns: 80% 20%;
        }
      }
      &--3 {
        background: url("../assets/images/home/hero_3.jpg") no-repeat;
        background-size: cover;
        grid-template-columns: 60% 40%;

        @include phone {
          grid-template-columns: 80% 20%;
        }
      }

      .left {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        h1 {
          color: white;

          @include phone {
            font-size: 0.8rem;
            width: 100%;
          }

          span {
            font-weight: 100;
          }
        }
      }
    }

    &__titulo {
      margin: 2rem auto 4rem auto;
      text-align: center;
      color: white;
    }

    &__empr {
      display: grid;
      grid-template-columns: 30% 70%;
      width: 90%;
      margin: 0 auto 6rem auto;
      max-width: 1200px;
      margin-bottom: 4rem;

      @include phone {
        display: flex;
        flex-direction: column;
      }
      
      .left {
        padding: 10px;
        background-color: #000000;

        @include phone {
          display: flex;
          flex-wrap: wrap;
        }

        iframe {
          width: 100% !important;
          height: auto;
          margin-bottom: 1rem;
        }

        &__datos {
          p {
            color: white;
            font-size: 0.8rem;
            margin-bottom: 1rem;
          }

          @include phone {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            column-gap: 10px;
          }
        }


        a {
          color: white;
          font-size: 0.8rem;
          overflow: hidden;
          word-break: break-word;
        }
      }

      .right {
        background-color: rgba($color: #FFFFFF, $alpha: 0.35);
        padding: 20px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;

        h3 {
          color: $main-color;
          font-size: 1.5rem;
          text-transform: uppercase;
        }

        p {
          color: white;
        }

        &__direccion {
          margin-bottom: 1rem;
          text-transform: uppercase;
        }

        &__botones {
          margin-top: auto;
          align-self: flex-end;

          button {
            background-color: white;
            padding: 5px 20px;
            color: #3B3B3B;
            border: 2px solid #707070;
            border-radius: 20px;
            font-size: 0.7rem;

            &:first-of-type{
              margin-right: 1rem;
            }

            @include phone {
              margin-top: 1rem;
            }
          }
        }
      }
    }
  }
</style>